<template>
    <div class="big-container">
        <span class="title">{{title}}</span>
        <div class="container-header">
            <slot name="button-left"></slot>
            <el-button type="success" size="mini" v-if="showRefreshButton" @click="onRefresh">刷新</el-button>
            <el-button type="warning" size="mini" v-if="showCloseButton" @click="close()">关闭</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HeaderContainer",
        props: {
            title: String,
            showRefreshButton: {
                type: Boolean,
                default: false,
            },
            showCloseButton: {
                type: Boolean,
                default: true,
            },
            onRefresh:
            {
                type: Function,
                default: ()=>{}
            }
        },
        methods: {
            close() {
                this.$store.dispatch('layout/routeBack');
            },
        }
    }
</script>

<style scoped>
    .title {
        font-size: 16px;
        font-weight: bold;
    }
    .big-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .container-header .permission-container
    {
        margin-right: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/container/HeaderContainer.vue